import React, { useCallback } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { Redirect } from 'react-router-dom';

import Button from 'components/Button';
import Spinner from 'components/Spinner/view/desktop';

import { awardsList, rankTypes } from '../../data';
import AgentItem from './AgentItem';
import { useCountdown } from '../../model/useCountdown';
import dogBackIMG from './img/dogBackBgDestktop.webp';
import dogFrontIMG from './img/dogFrontBgDesktop.webp';
import dogRightIMG from './img/dogSideBgDesktop.webp';
import heartIMG from './img/hearthBGDesktop.webp';
import volcanoIMG from './img/volcanoBGDesktop.webp';
import madIMG from './img/madBGDesktop.webp';
import rubyIMG from './img/rubyBGDesktop.webp';
import useRanking from '../../model/useRanking';

import './Ranking.scss';

const b = block('ranking-desktop');

const disabledRanks = [
  // rankTypes.providerGold
];

const Ranking = () => {
  const locale = useSelector(state => state.locale.locale);
  const { date } = useCountdown();
  const { actionProcessing, myRank, agentsRanking, month, toggleMonth, rubyPlayRanking } = useRanking();

  const awardsListItems = awardsList(myRank?.rank);
  const rankingTitle = locale.rankings?.[myRank?.rank] || locale.rankingTitle;

  const nowMonth = dayjs();
  const isMay2025 = nowMonth.isSame('2025-05', 'month');
  const isProveedoresSilverRank = myRank?.rank === rankTypes.providerSilver;
  const isDisabledForSpecial = isProveedoresSilverRank && isMay2025;

  const handleToggle = useCallback(() => {
    if (!isDisabledForSpecial) toggleMonth();
  }, [isDisabledForSpecial, toggleMonth]);

  // const isRubyList = rubyPlayRanking?.agentsRanking?.length > 0;
  const isRubyList = false;

  if (disabledRanks.includes(myRank?.rank)) return <Redirect to="/" />;

  return (
    <div className={b({ isRubyList, isProveedoresSilverRank })}>
      <Spinner isLoading={actionProcessing} />
      <div className={b('bg')}>
        <div className={b('agents-title')}>{locale.top10}</div>
        <section className={b('header')}>
          <h1 className={b('header-title')}>{rankingTitle}</h1>
          <span className={b('header-description')}>{locale.rankingDescription}</span>
        </section>
        <section className={b('awards')}>
          <div className={b('awards-container')}>
            {awardsListItems.map(item => (
              <article className={b('award')} key={item.key}>
                <img className={b('award-img')} src={item.imgDesk} alt={item.key} />
              </article>
            ))}
          </div>
        </section>
        <h2 className={b('agents-title-bg')}>{locale.top10}</h2>
      </div>
      <div className={b('content')}>
        <img
          src={dogBackIMG}
          alt="bg"
          className={b('bg-img', {
            type: 'back',
          })}
        />
        <img
          src={dogFrontIMG}
          alt="bg"
          className={b('bg-img', {
            type: 'front',
          })}
        />
        <img
          src={dogRightIMG}
          alt="bg"
          className={b('bg-img', {
            type: 'right',
          })}
        />
        <div className={b('tables')}>
          <section className={b('agents')}>
            <img
              src={heartIMG}
              alt="bg"
              className={b('bg-img', {
                type: 'heart',
              })}
            />
            <div className={b('agents-wrapper')}>
              <div className={b('agents-header')}>
                <div className={b('agents-header-td')} />
                <div className={b('agents-header-td')}>{locale.table.number}</div>
                <div className={b('agents-header-td')}>{locale.table.username}</div>
                <div className={b('agents-header-td')}>{locale.table.points}</div>
              </div>
              {agentsRanking.map((item, index) => (
                <AgentItem key={item.id} item={item} position={index + 1} />
              ))}
              {myRank && (
                <div className={b('current-position')}>
                  {locale.currentPosition.replace('{{value}}', myRank.position + 1)}
                </div>
              )}
            </div>
          </section>
          {isRubyList && isProveedoresSilverRank && (
            <section className={b('agents')}>
              <img
                src={volcanoIMG}
                alt="bg"
                className={b('bg-img', {
                  type: 'volcano',
                })}
              />
              <img
                src={rubyIMG}
                alt="bg"
                className={b('bg-img', {
                  type: 'ruby',
                })}
              />
              <img
                src={madIMG}
                alt="bg"
                className={b('bg-img', {
                  type: 'mad',
                })}
              />
              <div className={b('agents-wrapper')}>
                <div className={b('agents-header')}>
                  <div className={b('agents-header-td')} />
                  <div className={b('agents-header-td')}>{locale.table.number}</div>
                  <div className={b('agents-header-td')}>{locale.table.username}</div>
                  <div className={b('agents-header-td')}>{locale.table.points}</div>
                </div>
                {rubyPlayRanking?.agentsRanking?.map((item, index) => (
                  <AgentItem key={item?.id} item={item} position={index + 1} />
                ))}
                {rubyPlayRanking?.myRank && (
                  <div className={b('current-position')}>
                    {locale.currentPosition.replace('{{value}}', rubyPlayRanking?.myRank?.position + 1)}
                  </div>
                )}
              </div>
            </section>
          )}
        </div>

        <div className={b('timer-container')}>
          <span>{locale.daysRemaining}</span>
          <span className={b('timer')}>{date}</span>
        </div>
        <section className={b('bottom')}>
          <div className={b('rules')}>
            {locale.rules}&nbsp;<span className={b('click-here')}>{locale.clickHere}</span>
          </div>
          <div className={b('button')}>
            <Button
              size="low"
              text={month === 'current' ? locale.topOfLastMonth : locale.topOfCurrentMonth}
              callBack={handleToggle}
              color="purple"
              disabled={isDisabledForSpecial}
            />
          </div>
        </section>
      </div>
    </div>
  );
};

export default Ranking;
